var _path, _path2, _path3, _g, _g2, _path4, _g3, _path5, _g4, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoneAir(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 163,
    viewBox: "0 0 287 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M235.4 0C241.254 0.000211602 246 4.77609 246 10.667V77C222.252 77 203 96.2518 203 120C203 122.734 203.258 125.408 203.746 128H186.274C186.749 127.85 187.223 127.696 187.694 127.536C199.859 123.414 202.246 107.25 191.791 99.7881L188.971 97.7744C183.411 89.9928 174.423 85.3398 164.811 85.3398H140V10.667C140 4.77609 144.746 0.000212639 150.6 0H235.4Z",
    fill: "url(#paint0_linear_2892_2798)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M283.001 120.056C283.001 140.46 266.46 157 246.057 157C225.654 157 209.113 140.46 209.113 120.056C209.113 99.6528 225.654 83.1125 246.057 83.1125C266.46 83.1125 283.001 99.6528 283.001 120.056Z",
    fill: "#196BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M281.004 120.056C281.004 100.756 265.358 85.1095 246.057 85.1095C226.756 85.1095 211.11 100.756 211.11 120.056C211.11 139.357 226.756 155.003 246.057 155.003V157C225.654 157 209.113 140.46 209.113 120.056C209.113 99.6528 225.654 83.1125 246.057 83.1125C266.46 83.1125 283.001 99.6528 283.001 120.056C283.001 140.46 266.46 157 246.057 157V155.003C265.358 155.003 281.004 139.357 281.004 120.056Z",
    fill: "url(#paint1_linear_2892_2798)",
    fillOpacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2892_2798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.008 120.056C279.008 101.859 264.255 87.1064 246.058 87.1064C227.86 87.1064 213.108 101.859 213.108 120.056C213.108 138.254 227.86 153.006 246.058 153.006V154.005C227.309 154.005 212.109 138.805 212.109 120.056C212.109 101.307 227.309 86.1079 246.058 86.1079C264.807 86.1079 280.006 101.307 280.006 120.056C280.006 138.805 264.807 154.005 246.058 154.005V153.006C264.255 153.006 279.008 138.254 279.008 120.056Z",
    fill: "url(#paint2_linear_2892_2798)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2892_2798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.012 120.056C276.012 103.513 262.601 90.1019 246.058 90.1019C229.514 90.1019 216.103 103.513 216.103 120.056C216.103 136.6 229.514 150.011 246.058 150.011V154.005C227.309 154.005 212.109 138.805 212.109 120.056C212.109 101.307 227.309 86.1079 246.058 86.1079C264.807 86.1079 280.006 101.307 280.006 120.056C280.006 138.805 264.807 154.005 246.058 154.005V150.011C262.601 150.011 276.012 136.6 276.012 120.056Z",
    fill: "url(#paint3_linear_2892_2798)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2892_2798",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 209,
    y: 83,
    width: 74,
    height: 74
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M283.001 120.056C283.001 140.46 266.46 157 246.057 157C225.654 157 209.113 140.46 209.113 120.056C209.113 99.6528 225.654 83.1125 246.057 83.1125C266.46 83.1125 283.001 99.6528 283.001 120.056Z",
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2892_2798)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_g_2892_2798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.044 106.078C255.044 119.312 244.315 130.041 231.081 130.041C217.846 130.041 207.117 119.312 207.117 106.078C207.117 92.8428 217.846 82.114 231.081 82.114C244.315 82.114 255.044 92.8428 255.044 106.078Z",
    fill: "url(#paint4_linear_2892_2798)",
    fillOpacity: 0.4
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M278.009 120.056C278.009 102.41 263.704 88.1049 246.058 88.1049C228.411 88.1049 214.106 102.41 214.106 120.056C214.106 137.702 228.411 152.008 246.058 152.008V154.005C227.309 154.005 212.109 138.805 212.109 120.056C212.109 101.307 227.309 86.1079 246.058 86.1079C264.807 86.1079 280.006 101.307 280.006 120.056C280.006 138.805 264.807 154.005 246.058 154.005V152.008C263.704 152.008 278.009 137.702 278.009 120.056Z",
    fill: "url(#paint5_linear_2892_2798)",
    fillOpacity: 0.8
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_2892_2798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.639 107.245C260.89 104.819 264.681 104.677 267.106 106.928C269.531 109.178 269.673 112.969 267.423 115.394L246.505 137.934C244.929 139.633 242.242 139.638 240.66 137.944L224.706 120.872C222.447 118.455 222.575 114.664 224.992 112.405C227.41 110.146 231.201 110.274 233.46 112.691L242.093 121.929C242.884 122.776 244.227 122.774 245.015 121.924L258.639 107.245Z",
    fill: "#2B62C7"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M258.639 107.245C260.89 104.819 264.681 104.677 267.106 106.928C269.531 109.178 269.673 112.969 267.423 115.394L246.505 137.934C244.929 139.633 242.242 139.638 240.66 137.944L224.706 120.872C222.447 118.455 222.575 114.664 224.992 112.405C227.41 110.146 231.201 110.274 233.46 112.691L242.093 121.929C242.884 122.776 244.227 122.774 245.015 121.924L258.639 107.245Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M257.176 105.887C260.177 102.653 265.231 102.464 268.465 105.464L268.759 105.751C271.612 108.681 271.785 113.31 269.159 116.445L268.887 116.753L247.97 139.293C245.605 141.841 241.575 141.848 239.202 139.308L223.247 122.236C220.235 119.013 220.407 113.958 223.63 110.946C226.853 107.934 231.907 108.105 234.919 111.329L243.552 120.566L257.176 105.887ZM265.748 108.392C264.131 106.892 261.604 106.986 260.103 108.603L246.48 123.283C244.903 124.982 242.216 124.986 240.634 123.293L232.002 114.055C230.496 112.443 227.968 112.358 226.356 113.864C224.744 115.37 224.659 117.898 226.165 119.509L242.119 136.581C242.91 137.428 244.254 137.426 245.042 136.576L265.96 114.036C267.413 112.47 267.37 110.049 265.895 108.535L265.748 108.392Z",
    fill: "url(#paint6_linear_2892_2798)",
    fillOpacity: 0.54
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M257.175 105.887C257.926 105.078 259.189 105.031 259.997 105.781C260.806 106.532 260.853 107.795 260.103 108.603L246.479 123.283C244.902 124.982 242.216 124.987 240.633 123.294L232.001 114.055C231.248 113.249 231.291 111.986 232.096 111.233C232.902 110.48 234.165 110.523 234.918 111.329L243.552 120.566L257.175 105.887Z",
    fill: "url(#paint7_linear_2892_2798)",
    fillOpacity: 0.44
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M223.63 110.946C226.853 107.934 231.907 108.105 234.919 111.328L243.552 120.566C244.305 121.372 244.263 122.636 243.457 123.389C242.651 124.142 241.387 124.099 240.634 123.293L232.002 114.055C230.496 112.443 227.968 112.357 226.356 113.863C224.744 115.37 224.659 117.898 226.165 119.509L242.119 136.581C242.872 137.387 242.829 138.651 242.023 139.404C241.218 140.156 239.955 140.114 239.202 139.308L223.247 122.235C220.235 119.012 220.407 113.958 223.63 110.946Z",
    fill: "url(#paint8_linear_2892_2798)",
    fillOpacity: 0.4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0625 91.3403H106.034H164.811C172.8 91.3403 180.252 95.3662 184.631 102.049L188.306 104.671C194.779 109.291 193.302 119.3 185.769 121.853C179.129 124.103 172.166 125.25 165.156 125.25H93.4025H74.2853C68.9538 125.25 63.6358 124.713 58.4119 123.648L47.0824 121.337C32.3171 118.325 19.7538 108.697 13.0065 95.2225L11.0625 91.3403Z",
    fill: "url(#paint9_linear_2892_2798)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M160.544 102.483L161.871 101.156L185.519 102.941L187.749 104.28C185.416 105.446 182.804 105.941 180.205 105.709L161.096 104.003C160.341 103.936 160.008 103.019 160.544 102.483Z",
    fill: "url(#paint10_linear_2892_2798)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M71.7422 101.603C71.7422 100.37 72.741 99.3716 73.9731 99.3716C75.2052 99.3716 76.204 100.37 76.204 101.603V105.618H71.7422V101.603Z",
    fill: "url(#paint11_linear_2892_2798)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M63.7109 101.603C63.7109 100.37 64.7097 99.3716 65.9418 99.3716C67.1739 99.3716 68.1728 100.37 68.1728 101.603V105.618H63.7109V101.603Z",
    fill: "url(#paint12_linear_2892_2798)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M55.6797 101.603C55.6797 100.37 56.6785 99.3716 57.9106 99.3716C59.1427 99.3716 60.1415 100.37 60.1415 101.603V105.618H55.6797V101.603Z",
    fill: "url(#paint13_linear_2892_2798)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M79.7734 101.603C79.7734 100.37 80.7722 99.3716 82.0043 99.3716C83.2364 99.3716 84.2353 100.37 84.2353 101.603V105.618H79.7734V101.603Z",
    fill: "url(#paint14_linear_2892_2798)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M87.8047 101.603C87.8047 100.37 88.8035 99.3716 90.0356 99.3716C91.2677 99.3716 92.2665 100.37 92.2665 101.603V105.618H87.8047V101.603Z",
    fill: "url(#paint15_linear_2892_2798)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8359 101.603C95.8359 100.37 96.8347 99.3716 98.0668 99.3716C99.2989 99.3716 100.298 100.37 100.298 101.603V105.618H95.8359V101.603Z",
    fill: "url(#paint16_linear_2892_2798)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M103.867 101.603C103.867 100.37 104.866 99.3716 106.098 99.3716C107.33 99.3716 108.329 100.37 108.329 101.603V105.618H103.867V101.603Z",
    fill: "url(#paint17_linear_2892_2798)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M111.898 101.603C111.898 100.37 112.897 99.3716 114.129 99.3716C115.361 99.3716 116.36 100.37 116.36 101.603V105.618H111.898V101.603Z",
    fill: "url(#paint18_linear_2892_2798)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M119.93 101.603C119.93 100.37 120.928 99.3716 122.161 99.3716C123.393 99.3716 124.392 100.37 124.392 101.603V105.618H119.93V101.603Z",
    fill: "url(#paint19_linear_2892_2798)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M127.961 101.603C127.961 100.37 128.96 99.3716 130.192 99.3716C131.424 99.3716 132.423 100.37 132.423 101.603V105.618H127.961V101.603Z",
    fill: "url(#paint20_linear_2892_2798)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M135.992 101.603C135.992 100.37 136.991 99.3716 138.223 99.3716C139.455 99.3716 140.454 100.37 140.454 101.603V105.618H135.992V101.603Z",
    fill: "url(#paint21_linear_2892_2798)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M179.812 96.6945C181.658 98.2039 183.289 100.001 184.631 102.049L185.881 102.941H162.027C161.265 102.941 160.853 102.047 161.349 101.468L163.838 98.5646C164.855 97.378 166.34 96.6946 167.903 96.6945H179.812Z",
    fill: "url(#paint22_linear_2892_2798)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M179.812 96.6945C181.658 98.2039 183.289 100.001 184.631 102.049L185.881 102.941H162.027C161.265 102.941 160.853 102.047 161.349 101.468L163.838 98.5646C164.855 97.378 166.34 96.6946 167.903 96.6945H179.812Z",
    fill: "url(#paint23_linear_2892_2798)",
    fillOpacity: 0.4
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M191.32 112.757C191.32 116.207 189.322 119.004 186.858 119.004C184.394 119.004 182.396 116.207 182.396 112.757C182.396 109.307 184.394 106.511 186.858 106.511C189.322 106.511 191.32 109.307 191.32 112.757Z",
    fill: "url(#paint24_linear_2892_2798)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M224.714 80C225.901 80 226.998 80.37 227.88 80.9951C223.113 83.2132 218.823 86.2799 215.199 90H180.775C176.075 87.0024 170.555 85.3408 164.811 85.3408H156.014C156.006 85.2282 156 85.1146 156 85C156 82.2386 158.367 80 161.286 80H224.714Z",
    fill: "#3E83FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M156 32.2C156 29.3281 158.328 27 161.2 27H176.8C179.672 27 182 29.3281 182 32.2V47.8C182 50.6719 179.672 53 176.8 53H161.2C158.328 53 156 50.6719 156 47.8V32.2Z",
    fill: "url(#paint25_linear_2892_2798)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M188 32C188 29.2386 190.351 27 193.25 27H224.75C227.649 27 230 29.2386 230 32C230 34.7614 227.649 37 224.75 37H193.25C190.351 37 188 34.7614 188 32Z",
    fill: "url(#paint26_linear_2892_2798)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M156 66.5C156 63.4624 158.366 61 161.286 61H224.714C227.634 61 230 63.4624 230 66.5C230 69.5376 227.634 72 224.714 72H161.286C158.366 72 156 69.5376 156 66.5Z",
    fill: "url(#paint27_linear_2892_2798)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M188 48C188 45.2386 190.328 43 193.2 43H208.8C211.672 43 214 45.2386 214 48C214 50.7614 211.672 53 208.8 53H193.2C190.328 53 188 50.7614 188 48Z",
    fill: "url(#paint28_linear_2892_2798)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M209.051 98C207.026 101.393 205.455 105.087 204.423 109H197.995C197.846 108.351 197.654 107.709 197.42 107.078C197.394 107.009 197.368 106.939 197.341 106.87C197.294 106.748 197.245 106.628 197.194 106.507C197.171 106.451 197.148 106.395 197.124 106.339C197.009 106.072 196.886 105.808 196.755 105.547C196.729 105.495 196.703 105.443 196.676 105.391C196.639 105.319 196.603 105.247 196.564 105.176C196.504 105.062 196.441 104.949 196.377 104.836C196.341 104.772 196.303 104.708 196.266 104.645C196.228 104.58 196.188 104.516 196.149 104.451C196.094 104.36 196.038 104.269 195.98 104.179C195.927 104.095 195.873 104.012 195.818 103.929C195.783 103.876 195.748 103.822 195.712 103.77C195.535 103.511 195.35 103.256 195.155 103.006C195.13 102.973 195.105 102.941 195.079 102.908C194.983 102.786 194.885 102.665 194.784 102.545C194.758 102.513 194.731 102.482 194.704 102.45C194.625 102.358 194.545 102.267 194.464 102.176C194.425 102.132 194.386 102.089 194.347 102.046C194.243 101.933 194.139 101.821 194.031 101.71C194.009 101.688 193.987 101.666 193.965 101.644C193.86 101.537 193.753 101.43 193.645 101.325C193.623 101.305 193.602 101.284 193.58 101.264C193.459 101.149 193.336 101.035 193.211 100.923C193.175 100.891 193.138 100.859 193.102 100.827C192.839 100.596 192.567 100.371 192.284 100.153C192.275 100.146 192.265 100.139 192.256 100.132C192.104 100.015 191.95 99.9006 191.792 99.7881L189.289 98H209.051Z",
    fill: "#3E83FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0625 63.6771C11.0625 62.1986 12.2611 61 13.7396 61H21.4495C23.9929 61 26.3442 62.3532 27.6221 64.5523L43.1876 91.3403H11.0625V63.6771Z",
    fill: "url(#paint29_linear_2892_2798)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5903 105.146C17.1349 102.275 14.9981 99.1033 13.2383 95.6784L42.7403 93.5712L19.5903 105.146Z",
    fill: "url(#paint30_linear_2892_2798)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M11.062 91.3403H41.7016C42.522 91.3403 43.1871 92.0054 43.1871 92.8258C43.1871 93.5221 42.7035 94.1249 42.0238 94.2759L2.17991 103.13C0.353178 103.536 -0.787374 101.215 0.650196 100.017L11.062 91.3403Z",
    fill: "url(#paint31_linear_2892_2798)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1733 116.331C71.7428 112.048 83.6409 110.828 86.9129 110.977L75.6634 125.255H74.2848C69.3224 125.255 64.372 124.788 59.498 123.865C63.4215 120.845 66.8255 117.948 68.1733 116.331Z",
    fill: "url(#paint32_linear_2892_2798)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M127.961 125.25C128.318 120.61 132.274 116.475 134.208 114.988L111.898 125.25H127.961Z",
    fill: "url(#paint33_linear_2892_2798)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9277 145.774C61.9277 142.723 64.2153 140.156 67.2466 139.807L85.1292 137.743V153.806L67.2466 151.742C64.2153 151.393 61.9277 148.826 61.9277 145.774Z",
    fill: "url(#paint34_linear_2892_2798)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8051 145.774C87.8051 150.21 86.4068 153.806 84.6819 153.806C82.9569 153.806 81.5586 150.21 81.5586 145.774C81.5586 141.339 82.9569 137.743 84.6819 137.743C86.4068 137.743 87.8051 141.339 87.8051 145.774Z",
    fill: "url(#paint35_linear_2892_2798)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M86.913 145.774C86.913 149.717 85.9142 152.913 84.6821 152.913C83.45 152.913 82.4512 149.717 82.4512 145.774C82.4512 141.832 83.45 138.636 84.6821 138.636C85.9142 138.636 86.913 141.832 86.913 145.774Z",
    fill: "url(#paint36_linear_2892_2798)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0208 145.774C86.0208 147.746 85.4216 149.344 84.6823 149.344C83.943 149.344 83.3438 147.746 83.3438 145.774C83.3438 143.803 83.943 142.205 84.6823 142.205C85.4216 142.205 86.0208 143.803 86.0208 145.774Z",
    fill: "url(#paint37_linear_2892_2798)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4512 130.604C82.4512 127.553 84.7387 124.986 87.7701 124.636L105.653 122.573V138.636L87.7701 136.572C84.7387 136.222 82.4512 133.656 82.4512 130.604Z",
    fill: "url(#paint38_linear_2892_2798)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M108.331 130.604C108.331 135.04 106.932 138.636 105.207 138.636C103.482 138.636 102.084 135.04 102.084 130.604C102.084 126.169 103.482 122.573 105.207 122.573C106.932 122.573 108.331 126.169 108.331 130.604Z",
    fill: "url(#paint39_linear_2892_2798)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M107.436 130.604C107.436 134.547 106.438 137.743 105.206 137.743C103.973 137.743 102.975 134.547 102.975 130.604C102.975 126.662 103.973 123.465 105.206 123.465C106.438 123.465 107.436 126.662 107.436 130.604Z",
    fill: "url(#paint40_linear_2892_2798)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M106.544 130.604C106.544 132.576 105.945 134.174 105.206 134.174C104.466 134.174 103.867 132.576 103.867 130.604C103.867 128.633 104.466 127.035 105.206 127.035C105.945 127.035 106.544 128.633 106.544 130.604Z",
    fill: "url(#paint41_linear_2892_2798)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2231 115.416C79.0681 112.571 82.9267 110.972 86.95 110.972H131.149C132.839 110.972 134.208 112.342 134.208 114.031C134.208 115.168 133.578 116.211 132.571 116.74L48.6729 160.786C46.2419 162.063 43.5373 162.729 40.7917 162.729H33.218C31.628 162.729 30.8317 160.807 31.956 159.683L76.2231 115.416Z",
    fill: "url(#paint42_linear_2892_2798)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2892_2798",
    x: 208.109,
    y: 82.1079,
    width: 75.8965,
    height: 75.8966,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2892_2798"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2892_2798",
    x: 208.109,
    y: 82.1079,
    width: 75.8965,
    height: 75.8966,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2892_2798"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_g_2892_2798",
    x: 160.017,
    y: 35.014,
    width: 142.128,
    height: 142.127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "5 5",
    numOctaves: 3,
    seed: 5929
  }), /*#__PURE__*/React.createElement("feDisplacementMap", {
    in: "shape",
    scale: 94.19999694824219,
    xChannelSelector: "R",
    yChannelSelector: "G",
    result: "displacedImage",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_texture_2892_2798"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "displacedImage"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2892_2798",
    x: 209.492,
    y: 91.7286,
    width: 73.1297,
    height: 61.0827,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.8,
    result: "effect1_foregroundBlur_2892_2798"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2892_2798",
    x1: 193,
    y1: 0,
    x2: 193,
    y2: 128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144231,
    stopColor: "#F4F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#E1ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2892_2798",
    x1: 222.044,
    y1: 90.9631,
    x2: 265.914,
    y2: 153.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E825AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2892_2798",
    x1: 226.331,
    y1: 91.1543,
    x2: 268.078,
    y2: 149.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456731,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2892_2798",
    x1: 226.331,
    y1: 91.1543,
    x2: 268.078,
    y2: 149.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.586538,
    stopColor: "#1157D5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1157D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2892_2798",
    x1: 231.081,
    y1: 82.114,
    x2: 231.081,
    y2: 130.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2892_2798",
    x1: 223.991,
    y1: 94.1707,
    x2: 267.7,
    y2: 147.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.100962,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2892_2798",
    x1: 241.065,
    y1: 108.075,
    x2: 263.531,
    y2: 130.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1A428C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A428C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2892_2798",
    x1: 243.56,
    y1: 107.076,
    x2: 253.046,
    y2: 123.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49263,
    stopColor: "#005BFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#196BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2892_2798",
    x1: 241.564,
    y1: 124.549,
    x2: 231.08,
    y2: 133.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1A428C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A428C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2892_2798",
    x1: 107.438,
    y1: 91.3403,
    x2: 107.438,
    y2: 125.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144231,
    stopColor: "#F4F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#E1ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783654,
    stopColor: "#D7E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5CBF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2892_2798",
    x1: 173.472,
    y1: 101.603,
    x2: 173.472,
    y2: 106.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144231,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#E1ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2892_2798",
    x1: 73.9731,
    y1: 99.3716,
    x2: 73.9731,
    y2: 105.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ABEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413462,
    stopColor: "#639BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B77FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2892_2798",
    x1: 65.9418,
    y1: 99.3716,
    x2: 65.9418,
    y2: 105.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ABEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413462,
    stopColor: "#639BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B77FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2892_2798",
    x1: 57.9106,
    y1: 99.3716,
    x2: 57.9106,
    y2: 105.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ABEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413462,
    stopColor: "#639BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B77FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2892_2798",
    x1: 82.0043,
    y1: 99.3716,
    x2: 82.0043,
    y2: 105.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ABEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413462,
    stopColor: "#639BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B77FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2892_2798",
    x1: 90.0356,
    y1: 99.3716,
    x2: 90.0356,
    y2: 105.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ABEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413462,
    stopColor: "#639BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B77FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2892_2798",
    x1: 98.0668,
    y1: 99.3716,
    x2: 98.0668,
    y2: 105.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ABEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413462,
    stopColor: "#639BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B77FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2892_2798",
    x1: 106.098,
    y1: 99.3716,
    x2: 106.098,
    y2: 105.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ABEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413462,
    stopColor: "#639BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B77FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2892_2798",
    x1: 114.129,
    y1: 99.3716,
    x2: 114.129,
    y2: 105.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ABEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413462,
    stopColor: "#639BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B77FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2892_2798",
    x1: 122.161,
    y1: 99.3716,
    x2: 122.161,
    y2: 105.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ABEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413462,
    stopColor: "#639BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B77FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2892_2798",
    x1: 130.192,
    y1: 99.3716,
    x2: 130.192,
    y2: 105.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ABEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413462,
    stopColor: "#639BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B77FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2892_2798",
    x1: 138.223,
    y1: 99.3716,
    x2: 138.223,
    y2: 105.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ABEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413462,
    stopColor: "#639BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B77FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2892_2798",
    x1: 173.507,
    y1: 96.6945,
    x2: 173.507,
    y2: 102.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ABEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413462,
    stopColor: "#639BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778846,
    stopColor: "#2B77FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2892_2798",
    x1: 161.133,
    y1: 99.8178,
    x2: 182.842,
    y2: 95.8022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.625564,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2892_2798",
    x1: 186.858,
    y1: 106.511,
    x2: 186.858,
    y2: 119.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144231,
    stopColor: "#F4F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#E1ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2892_2798",
    x1: 169,
    y1: 27,
    x2: 169,
    y2: 53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ABEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413462,
    stopColor: "#639BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B77FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2892_2798",
    x1: 209,
    y1: 27,
    x2: 209,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ABEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413462,
    stopColor: "#639BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B77FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2892_2798",
    x1: 193,
    y1: 61,
    x2: 193,
    y2: 72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ABEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413462,
    stopColor: "#639BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B77FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2892_2798",
    x1: 201,
    y1: 43,
    x2: 201,
    y2: 53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ABEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413462,
    stopColor: "#639BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B77FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2892_2798",
    x1: 27.125,
    y1: 61,
    x2: 27.125,
    y2: 91.3403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144231,
    stopColor: "#F4F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#E1ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2892_2798",
    x1: 42.7403,
    y1: 99.4042,
    x2: 13.2383,
    y2: 99.4042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCBE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2892_2798",
    x1: 21.5935,
    y1: 91.3403,
    x2: 21.5935,
    y2: 103.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144231,
    stopColor: "#F4F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#E1ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2892_2798",
    x1: 73.2055,
    y1: 125.255,
    x2: 73.2055,
    y2: 110.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8BBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2892_2798",
    x1: 123.053,
    y1: 125.25,
    x2: 123.053,
    y2: 114.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8BBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2892_2798",
    x1: 85.1292,
    y1: 145.838,
    x2: 61.9277,
    y2: 145.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCBE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2892_2798",
    x1: 87.8051,
    y1: 145.838,
    x2: 81.5586,
    y2: 145.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2892_2798",
    x1: 86.913,
    y1: 145.831,
    x2: 82.4512,
    y2: 145.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCBE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2892_2798",
    x1: 84.6823,
    y1: 142.205,
    x2: 84.6823,
    y2: 149.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144231,
    stopColor: "#F4F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#E1ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2892_2798",
    x1: 105.653,
    y1: 130.668,
    x2: 82.4512,
    y2: 130.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCBE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2892_2798",
    x1: 108.331,
    y1: 130.668,
    x2: 102.084,
    y2: 130.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2892_2798",
    x1: 107.436,
    y1: 130.661,
    x2: 102.975,
    y2: 130.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCBE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2892_2798",
    x1: 105.206,
    y1: 127.035,
    x2: 105.206,
    y2: 134.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144231,
    stopColor: "#F4F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#E1ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2892_2798",
    x1: 82.8189,
    y1: 110.972,
    x2: 82.8189,
    y2: 162.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144231,
    stopColor: "#F4F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#E1ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E5FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneAir);
export default __webpack_public_path__ + "static/media/doneAir.d5326136e88bcd17b84428eea2392b7b.svg";
export { ForwardRef as ReactComponent };